import { combineReducers } from "redux";
import errorReducer from "./ErrorResponse/Reducer";
import renewalReducer from "./PolicyNumber/reducer";

// add reducers here
const rootReducer = combineReducers({
    policyDetails:renewalReducer,
    error:errorReducer,
});

export default rootReducer;
